import React from "react";
import { Skeleton } from "primereact/skeleton";
import "./AppSkeleton.css";

interface AppSkeletonProps {
    count?: number;
    width?: string;
    height?: string;
    borderRadius?: string;
    className?: string;
    containerClassName?: string;
}

const AppSkeleton: React.FC<AppSkeletonProps> = ({
    count = 1,
    width = "100%",
    height = "1rem",
    borderRadius = "8px",
    className = "",
    containerClassName = "",
}) => {
    return (

        <div className={`app-skeleton-list ${containerClassName}`.trim()}>
            {Array.from({ length: count }).map((_, index) => (
                <div key={index} className={`app-skeleton-item ${className}`.trim()}>

                    <Skeleton width={width} height={height} borderRadius={borderRadius} />
                </div>
            ))}
        </div>
    );
};

export default AppSkeleton;
